"use strict";
/*
 * Created on 17. 12. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Promise wrapper contains promise that can be finished (resolved or rejected) by calling methods of the wrapper.
 * Promise may be finished only once, attempt to finish promise repeatedly will result in exception.
 * Similar to Scala Promise class.
 *
 * @author Stepan Mik
 */

var PromiseWrapper =
/*#__PURE__*/
function () {
  function PromiseWrapper() {
    var _this = this;

    _classCallCheck(this, PromiseWrapper);

    this.finish = false;
    this._promise = new Promise(function (resolve, reject) {
      _this._reject = reject;
      _this._resolve = resolve;
    });
  }

  _createClass(PromiseWrapper, [{
    key: "assertNotFinished",
    value: function assertNotFinished() {
      if (this.finish) {
        throw new Error('PromiseWrapper already finished');
      }
    }
  }, {
    key: "resolve",
    value: function resolve(value) {
      this.assertNotFinished();
      this.finish = true;

      this._resolve(value);
    }
  }, {
    key: "reject",
    value: function reject(reason) {
      this.assertNotFinished();
      this.finish = true;

      this._reject(reason);
    }
  }, {
    key: "finishWith",
    value: function finishWith(promise) {
      var _this2 = this;

      this.assertNotFinished();
      this.finish = true;
      promise.then(function (v) {
        return _this2._resolve(v);
      }, function (err) {
        return _this2._reject(err);
      });
    }
  }, {
    key: "finishWithStream",
    value: function finishWithStream(stream, result) {
      var _this3 = this;

      this.assertNotFinished();
      this.finish = true;
      stream.on('error', function (err) {
        return _this3._reject(err);
      });
      stream.on('finish', function () {
        return _this3._resolve(result());
      });
    }
  }, {
    key: "promise",
    get: function get() {
      return this._promise;
    }
  }, {
    key: "finished",
    get: function get() {
      return this.finish;
    }
  }]);

  return PromiseWrapper;
}();

exports.PromiseWrapper = PromiseWrapper;